module.exports = __webpack_public_path__ + "img/profile.bb6249e3.svg";